import {apiUrl} from "../../../setting";

export const patientSaleUrl = () => {
    return `${apiUrl}/v2/patient-sales`
}
export const patientPurchaseUrl = () => {
    return `${apiUrl}/v2/patient-purchase`
}
export const patientCreditNoteUrl = () => {
    return `${apiUrl}/v2/patient-credit-note`
}
export const patientDebitNoteUrl = () => {
    return `${apiUrl}/v2/patient-debit-note`
}
export const patientPaymentInUrl = () => {
    return `${apiUrl}/v2/patient-payment-in`
}
export const patientPaymentOutUrl = () => {
    return `${apiUrl}/v2/patient-payment-out`
}
export const singlePatientUrl = () => {
    return `${apiUrl}/v2/get-single-patient`
}
export const addPaymentInUrl = () => {
    return `${apiUrl}/v2/add-payment-in`
}
export const updateCustomerActiveStatusUrl = () => {
    return `${apiUrl}/v2/update-customer-active-status`
}